import { Stack, Typography } from '@mui/material'
import { preview } from '@/components/form/preview'
import { useAggregateLoadsCf } from '../../../../../components/DynamicLoadsCf/hooks/useAggregateLoadsCf'
import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function Loads(props: Props) {
  const { extOrder } = props

  const loads = extOrder.order.loads || {}
  const trackedLoads = extOrder.orderStep.trackingData?.loadTrackedMap || {}

  const texts = useTexts()
  const { aggregateLoads } = useAggregateLoadsCf({
    loads,
    trackedLoads,
    customFields: {},
    trackedCustomFields: {},
  })

  if (aggregateLoads.length === 0) {
    return null
  }

  return (
    <Stack spacing={2}>
      {aggregateLoads.map((aggregateLoad, idx) => {
        if (aggregateLoad.value === 'undeclared') {
          return (
            <preview.Field
              key={aggregateLoad.label}
              label={aggregateLoad.label}
              testId={`execution-load-${idx}`}
            >
              {texts.undeclared.label}
            </preview.Field>
          )
        }

        const { trackedValue, delta } = aggregateLoad
        const deltaText = delta !== 0 ? ` (${delta > 0 ? '+' : ''}${delta})` : ''

        return (
          <preview.Field
            key={aggregateLoad.label}
            label={aggregateLoad.label}
            testId={`execution-load-${idx}`}
          >
            {trackedValue}
            {deltaText && (
              <Typography
                component="span"
                variant="body2"
                color={delta > 0 ? 'success.main' : 'error.main'}
              >
                {deltaText}
              </Typography>
            )}
          </preview.Field>
        )
      })}
    </Stack>
  )
}
